const FRAGS = [{"id":"oud_al_malik","ar":"عود الملك","en":"Oud Al Malik","western":"Reign","translation":"King's Oud","family":"oud","familyLabel":"Dark Oud","accords":["Woody","Oud","Smooth","Refined"],"topNotes":["Rosewood","Cardamom","Sichuan Pepper"],"heartNotes":["Oud","Sandalwood","Vetiver"],"baseNotes":["Tonka Bean","Amber","Cedar"],"desc":"Oud at its most composed and regal — rosewood and cardamom giving way to smooth agarwood, sandalwood and amber. Quietly commanding.","prices":{"6ml":90,"8ml":120,"12ml":175,"25ml":305,"50ml":425},"bottleColor":"#1A0A02","capColor":"#8B6914","bodyGrad":["#0A0602","#1E0C04","#0A0602"],"gender":"unisex"},{"id":"dhahab_al_sharq","ar":"ذهب الشرق","en":"Dhahab Al Sharq","western":"The Gilded","translation":"Gold of the East","family":"oriental","familyLabel":"Oriental","accords":["Spicy","Gourmand","Warm","Golden"],"topNotes":["Cinnamon","Nutmeg","Coffee"],"heartNotes":["Dates","Praline","Tuberose"],"baseNotes":["Tonka Bean","Vanilla","Oud"],"desc":"Warm spice and dark coffee folded into dates and praline, sweetened with tonka and vanilla over a whisper of oud. Golden and gourmand.","prices":{"6ml":90,"8ml":120,"12ml":175,"25ml":305,"50ml":425},"bottleColor":"#252318","capColor":"#3A3020","bodyGrad":["#10100A","#252318","#0C0C08"],"gender":"unisex"},{"id":"zafran_al_malik","ar":"زعفران الملك","en":"Zafran Al Malik","western":"The Gold Standard","translation":"King's Saffron","family":"oriental","familyLabel":"Oriental","accords":["Saffron","Rich","Ambery","Opulent"],"topNotes":["Saffron","Bergamot"],"heartNotes":["Rose","Oud"],"baseNotes":["Amber","Vanilla","Musk"],"desc":"Saffron at its most extravagant — woven with rose and oud, sealed in amber and vanilla. The most opulent expression in the collection.","prices":{"6ml":90,"8ml":120,"12ml":175,"25ml":305,"50ml":425},"bottleColor":"#2A1A04","capColor":"#5A4010","bodyGrad":["#1A1002","#2A1A04","#1A1002"],"gender":"unisex"},{"id":"oud_al_layl","ar":"عود الليل","en":"Oud Al Layl","western":"The Dark Hour","translation":"Night Oud","family":"oud","familyLabel":"Dark Oud","accords":["Tobacco","Dark Wood","Resinous","Smoky"],"topNotes":["Tobacco Leaf","Spices"],"heartNotes":["Oud","Cedar"],"baseNotes":["Dark Resins","Amber","Leather"],"desc":"Tobacco and agarwood smouldering together — spice, cedar and dark resin wrapped in leather and amber. A perfume of depth and quiet power.","prices":{"6ml":75,"8ml":100,"12ml":150,"25ml":265,"50ml":370},"bottleColor":"#3D1608","capColor":"#2A0E04","bodyGrad":["#0E0503","#3D1608","#0A0302"],"gender":"masculine"},{"id":"jabal_al_nar","ar":"جبل النار","en":"Jabal Al Nar","western":"Fire Mountain","translation":"Mountain of Fire","family":"oriental","familyLabel":"Oriental","accords":["Tobacco","Warm","Sweet","Spicy"],"topNotes":["Tobacco Leaf","Ginger","Spice"],"heartNotes":["Tobacco Blossom","Cocoa","Tonka Bean"],"baseNotes":["Vanilla","Dried Fruits","Woods"],"desc":"Rich pipe tobacco melting into cocoa, tonka and vanilla, lifted by spice and dried fruit. Warm, smoky and impossible to ignore.","prices":{"6ml":75,"8ml":100,"12ml":150,"25ml":265,"50ml":370},"bottleColor":"#100804","capColor":"#1E1008","bodyGrad":["#080402","#100804","#080402"],"gender":"unisex"},{"id":"qalb_al_layl","ar":"قلب الليل","en":"Qalb Al Layl","western":"The Depths","translation":"Heart of Night","family":"woody","familyLabel":"Woody","accords":["Woody","Ambery","Dry","Mineral"],"topNotes":["Ambergris","Pepper"],"heartNotes":["Cedar","Vetiver"],"baseNotes":["Dry Woods","Musk"],"desc":"Clean ambergris over dry cedar and vetiver — woody, mineral and bracing. Restrained darkness worn close to the skin.","prices":{"6ml":75,"8ml":100,"12ml":150,"25ml":265,"50ml":370},"bottleColor":"#1C1008","capColor":"#2E1A10","bodyGrad":["#0C0804","#1C1008","#0C0804"],"gender":"masculine"},{"id":"ward_al_arz","ar":"وردة الأرز","en":"Ward Al Arz","western":"Alpine Rose","translation":"Cedar Rose","family":"floral","familyLabel":"Floral","accords":["Rose","Sweet","Fruity","Soft"],"topNotes":["Lychee","Bergamot"],"heartNotes":["Turkish Rose","Jasmine"],"baseNotes":["Vanilla","White Musk"],"desc":"Turkish rose and lychee melting into soft vanilla and white musk. Delicate, fruity and enduring — a bloom that lingers.","prices":{"6ml":75,"8ml":100,"12ml":150,"25ml":265,"50ml":370},"bottleColor":"#F0E8D4","capColor":"#C8BCA0","bodyGrad":["rgba(240,232,215,.08)","rgba(255,248,235,.16)","rgba(240,232,215,.06)"],"gender":"feminine"},{"id":"zahra_al_layl","ar":"زهرة الليل","en":"Zahra Al Layl","western":"The White Hour","translation":"Night Flower","family":"gourmand","familyLabel":"Gourmand","accords":["Powdery","Vanilla","Soft","Sensual"],"topNotes":["Powdery Aldehydes"],"heartNotes":["Heliotrope","Vanilla Orchid"],"baseNotes":["Tonka Bean","Soft Woods","Musk"],"desc":"Powdered vanilla and heliotrope over tonka and soft woods — pale, intimate and skin-soft. Quiet luxury at its most tactile.","prices":{"6ml":75,"8ml":100,"12ml":150,"25ml":265,"50ml":370},"bottleColor":"#E8E0F0","capColor":"#C8B8D8","bodyGrad":["rgba(232,224,240,.08)","rgba(244,236,252,.15)","rgba(232,224,240,.06)"],"gender":"feminine"},{"id":"sihr_al_masaa","ar":"سحر المساء","en":"Sihr Al Masaa","western":"The Seduction","translation":"Evening Magic","family":"floral","familyLabel":"Floral","accords":["Floral","Gourmand","Sweet","Magnetic"],"topNotes":["Almond","Lemon","Bergamot"],"heartNotes":["Tuberose","Jasmine Sambac","Cocoa"],"baseNotes":["Tonka Bean","Vanilla","Cacao"],"desc":"Tuberose and jasmine laced with almond and cocoa, grounded in tonka and vanilla. A slow, magnetic seduction told in notes.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#1A0E06","capColor":"#3D2010","bodyGrad":["#0E0802","#1A0E06","#0E0802"],"gender":"feminine"},{"id":"samt_al_sahara","ar":"صمت الصحراء","en":"Samt Al Sahara","western":"The Empty Quarter","translation":"Desert Silence","family":"oriental","familyLabel":"Oriental","accords":["Boozy","Gourmand","Warm","Woody"],"topNotes":["Cognac","Cinnamon"],"heartNotes":["Oak","Praline","Tonka"],"baseNotes":["Vanilla","Sandalwood","Amber"],"desc":"Aged cognac and cinnamon over oak, praline and tonka, settling into vanilla and amber. Vast, warm and contemplative.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#2A1C08","capColor":"#4A3010","bodyGrad":["#1A1008","#2A1C08","#1A1008"],"gender":"unisex"},{"id":"ward_al_fajr","ar":"وردة الفجر","en":"Ward Al Fajr","western":"Dawn Bloom","translation":"Dawn Rose","family":"floral","familyLabel":"Floral","accords":["Fruity","Floral","Fresh","Luminous"],"topNotes":["Pear","Peach"],"heartNotes":["Apple Blossom","Jasmine","Freesia"],"baseNotes":["Vanilla","Soft Musk","Sandalwood"],"desc":"Pear and peach blossom opening into apple blossom and jasmine, dried down with vanilla and soft musk. Luminous and full of first light.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#F5EAE8","capColor":"#E0C8C0","bodyGrad":["rgba(245,234,232,.08)","rgba(255,240,236,.15)","rgba(245,234,232,.06)"],"gender":"feminine"},{"id":"yasmin_al_sham","ar":"ياسمين الشام","en":"Yasmin Al Sham","western":"Damascus","translation":"Levantine Jasmine","family":"floral","familyLabel":"Floral","accords":["Jasmine","White Floral","Heady","Soft"],"topNotes":["Citrus","Neroli"],"heartNotes":["Jasmine Sambac","White Florals"],"baseNotes":["Soft Musk","Vanilla"],"desc":"Jasmine sambac at its most lush, lifted with citrus and softened by musk and vanilla. The rooftops of Damascus in full summer bloom.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#F0F0E8","capColor":"#D8D0A8","bodyGrad":["rgba(240,240,232,.08)","rgba(252,252,240,.15)","rgba(240,240,232,.06)"],"gender":"unisex"},{"id":"bukhoor_al_sham","ar":"بخور الشام","en":"Bukhoor Al Sham","western":"Frankincense","translation":"Levantine Incense","family":"oriental","familyLabel":"Oriental","accords":["Rich","Smoky","Sweet","Deep"],"topNotes":["Spice"],"heartNotes":["Tobacco","Dark Caramel"],"baseNotes":["Intense Vanilla","Amber","Woods"],"desc":"The deepest, smokiest vanilla in the house — dark caramel and tobacco over amber and woods. Dense, resinous and built to last.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#1E1206","capColor":"#3A2010","bodyGrad":["#100A02","#1E1206","#100A02"],"gender":"unisex"},{"id":"anbar_al_khalij","ar":"عنبر الخليج","en":"Anbar Al Khalij","western":"Gulf Amber","translation":"Arabian Amber","family":"oriental","familyLabel":"Oriental","accords":["Amber","Vanilla","Warm","Smooth"],"topNotes":["Brown Sugar"],"heartNotes":["Vanilla","Tonka"],"baseNotes":["Amber","Musk","Woods"],"desc":"Brown sugar and vanilla wrapped in warm amber, tonka and musk. Golden, smooth and softly addictive — it embraces rather than announces.","prices":{"6ml":60,"8ml":80,"12ml":120,"25ml":225,"50ml":315},"bottleColor":"#2A1A06","capColor":"#6A4A18","bodyGrad":["#1A1004","#2A1A06","#1A1004"],"gender":"unisex"},{"id":"ruh_al_arz","ar":"روح الأرز","en":"Ruh Al Arz","western":"4,000 Years","translation":"Soul of Cedar","family":"gourmand","familyLabel":"Gourmand","accords":["Vanilla","Soft","Warm","Serene"],"topNotes":["Soft Vanilla"],"heartNotes":["Tonka Bean","Heliotrope"],"baseNotes":["Soft Amber","Musk","Light Woods"],"desc":"The gentlest vanilla in the collection — tonka and heliotrope over soft amber and light woods. Serene, enduring, worn like a second skin.","prices":{"6ml":55,"8ml":72,"12ml":108,"25ml":195,"50ml":275},"bottleColor":"#0E1A10","capColor":"#1E3020","bodyGrad":["#081008","#0E1A10","#081008"],"gender":"unisex"},{"id":"nismat_al_bahr","ar":"نسمة البحر","en":"Nismat Al Bahr","western":"Salt & Cedar","translation":"Sea Breeze","family":"woody","familyLabel":"Woody","accords":["Marine","Fresh","Woody","Aromatic"],"topNotes":["Grapefruit","Marine Accord","Mandarin"],"heartNotes":["Bay Leaf","Jasmine","Sea Notes"],"baseNotes":["Guaiac Wood","Ambergris","Cedar"],"desc":"Grapefruit and sea spray over a bracing marine heart, drying down to guaiac wood and ambergris. The Mediterranean at dawn — salt air and cedar.","prices":{"6ml":55,"8ml":72,"12ml":108,"25ml":195,"50ml":275},"bottleColor":"#0A1620","capColor":"#1A2E40","bodyGrad":["#060E14","#0A1620","#060E14"],"gender":"masculine"},{"id":"mazaj_al_raheel","ar":"مزاج الرحيل","en":"Mazaj Al Raheel","western":"Bon Voyage","translation":"Mood of Departure","family":"floral","familyLabel":"Floral","accords":["Sparkling","Fruity","Floral","Sweet"],"topNotes":["Pink Champagne","Sparkling Currant"],"heartNotes":["Freesia","Peony"],"baseNotes":["Vanilla","Sandalwood","Musk"],"desc":"Pink champagne and sparkling currant over freesia and peony, settling into vanilla and sandalwood. Effervescent and celebratory — a fond farewell.","prices":{"6ml":55,"8ml":72,"12ml":108,"25ml":195,"50ml":275},"bottleColor":"#1A1208","capColor":"#302010","bodyGrad":["#100C04","#1A1208","#100C04"],"gender":"feminine"},{"id":"nahr_al_dhahab","ar":"نهر الذهب","en":"Nahr Al Dhahab","western":"The Flow","translation":"River of Gold","family":"gourmand","familyLabel":"Gourmand","accords":["Sweet","Vanilla","Caramel","Smooth"],"topNotes":["Sugar","Caramel"],"heartNotes":["Vanilla","Marshmallow"],"baseNotes":["Tonka Bean","Light Musk"],"desc":"Spun sugar and caramel over creamy vanilla and marshmallow, smoothed with tonka and musk. Luminous, sweet and impossibly easy to wear.","prices":{"6ml":55,"8ml":72,"12ml":108,"25ml":195,"50ml":275},"bottleColor":"#201806","capColor":"#3A2C0A","bodyGrad":["#161004","#201806","#161004"],"gender":"unisex"}];
const SIZES = ['6ml','8ml','12ml','25ml','50ml'];
const SIZE_NOTES = {'6ml':'Pure Concentrate','8ml':'Classic Oil','12ml':'Generous','25ml':'Collector','50ml':'Extrait EDP'};
let curSize = '6ml', curFrag = null, packAdd = 0, sizeAdd = 0;

// BOTTLE SVG
function bsvg(f,w,h) {
  const lt = f.family==='floral'||f.family==='woody';
  const g = f.bodyGrad, cid='b_'+f.id;
  const cx=w/2, cW=w*.38, cH=h*.13, nW=w*.5, nH=h*.04;
  const bW=w*.84, bH=h*.77, bY=cH+nH, bX=cx-bW/2;
  const lH=bH*.32, lY=bY+bH*.44, lX=bX+bW*.14, lW=bW*.72;
  const gd = lt
    ? `<linearGradient id="${cid}" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="${g[0]}"/><stop offset="45%" stop-color="${g[1]}"/><stop offset="100%" stop-color="${g[2]}"/></linearGradient>`
    : `<linearGradient id="${cid}" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="${g[0]}"/><stop offset="40%" stop-color="${g[1]}"/><stop offset="100%" stop-color="${g[2]}"/></linearGradient>`;
  return `<defs>${gd}
    <linearGradient id="${cid}s" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="rgba(255,255,255,${lt?.18:.08})"/><stop offset="100%" stop-color="transparent"/></linearGradient>
    <linearGradient id="${cid}l" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="rgba(201,168,76,.12)"/><stop offset="100%" stop-color="rgba(201,168,76,.04)"/></linearGradient>
  </defs>
  <rect x="${cx-cW/2}" y="0" width="${cW}" height="${cH}" rx="${cH*.28}" fill="${f.capColor}" stroke="rgba(201,168,76,.35)" stroke-width="1.2"/>
  <rect x="${cx-nW/2}" y="${cH-1}" width="${nW}" height="${nH+2}" rx="3" fill="${lt?'rgba(200,188,160,.4)':'#1A0A04'}" stroke="rgba(201,168,76,.2)" stroke-width="1"/>
  <rect x="${bX}" y="${bY}" width="${bW}" height="${bH}" rx="6" fill="url(#${cid})" stroke="rgba(201,168,76,.45)" stroke-width="1.4"/>
  <rect x="${bX}" y="${bY}" width="${bW}" height="${bH*.35}" rx="6" fill="url(#${cid}s)"/>
  <rect x="${bX+bW*.07}" y="${bY+bH*.12}" width="${bW*.07}" height="${bH*.52}" rx="3" fill="rgba(255,255,255,${lt?.07:.03})"/>
  <rect x="${lX}" y="${lY}" width="${lW}" height="${lH}" rx="2" fill="url(#${cid}l)" stroke="rgba(201,168,76,.22)" stroke-width="1"/>`;
}

// GRID
function buildGrid(fam) {
  const grid = document.getElementById('cgrid');
  grid.innerHTML='';
  const list = FRAGS.filter(f=>(activeFam==='all'||f.family===activeFam) && (activeGender==='all'||f.gender===activeGender));
  list.forEach(f => {
    const p = '£'+f.prices[curSize];
    const c = document.createElement('div');
    c.className='pcard'; c.dataset.fid=f.id;
    c.innerHTML=`<div class="pc-inner">
      <div class="pc-glow"></div>
      <div class="pc-bottle"><svg width="68" height="185" viewBox="0 0 68 185" fill="none">${bsvg(f,68,185)}</svg></div>
      <span class="pc-fam">${f.familyLabel} &middot; ${genderLabel(f.gender)}</span>
      <span class="pc-ar">${f.ar}</span>
      <div class="pc-names"><span class="pc-en">${f.en}</span><span class="pc-west">${f.western}</span></div>
      <span class="pc-price" id="price_${f.id}">${curSize} &nbsp;<span class="pc-price-size">— £</span> ${f.prices[curSize]}</span>
      <div class="pc-acts">
        <button class="pc-btn" onclick="openMod('${f.id}')">Select</button>
        <button class="pc-deet" onclick="openMod('${f.id}')">Details</button>
      </div>
    </div><div class="pc-bdr"></div>`;
    c.addEventListener('mouseenter',()=>{ring.style.width='48px';ring.style.height='48px';ring.style.borderColor='rgba(201,168,76,.8)'});
    c.addEventListener('mouseleave',()=>{ring.style.width='32px';ring.style.height='32px';ring.style.borderColor='rgba(201,168,76,.45)'});
    grid.appendChild(c);
  });
}

let activeFam='all', activeGender='all';
function genderLabel(g){return g==='feminine'?'Feminine':g==='masculine'?'Masculine':'Unisex';}
function setSize(sz) {
  curSize=sz;
  document.querySelectorAll('.st-btn').forEach(b=>b.classList.remove('act'));
  event.target.classList.add('act');
  FRAGS.forEach(f=>{
    const el=document.getElementById('price_'+f.id);
    if(el) el.innerHTML=sz+' &nbsp;<span class="pc-price-size">— £</span> '+f.prices[sz];
  });
}
function filterFam(fam,el) {
  activeFam=fam;
  document.querySelectorAll('.ffb').forEach(b=>b.classList.remove('act'));
  el.classList.add('act');
  buildGrid();
}
function filterGender(g,el) {
  activeGender=g;
  document.querySelectorAll('.gfb').forEach(b=>b.classList.remove('act'));
  el.classList.add('act');
  buildGrid();
}

// MODAL
let mSelSize='6ml';
function openMod(id) {
  const f=FRAGS.find(x=>x.id===id); if(!f) return;
  curFrag=f; mSelSize=curSize;
  document.getElementById('mAr').innerHTML=f.ar;
  document.getElementById('mEn').textContent=f.en;
  document.getElementById('mWest').textContent=f.western;
  document.getElementById('mTrans').textContent='"'+f.translation+'"';
  document.getElementById('mFam').textContent=f.familyLabel;
  document.getElementById('mAccords').innerHTML=f.accords.map(a=>`<span class="acc-tag">${a}</span>`).join('');
  document.getElementById('mDesc').textContent=f.desc;
  document.getElementById('mNotes').innerHTML=`
    <div><span class="mn-col-lbl">Top</span>${f.topNotes.map(n=>`<span class="mn-note">${n}</span>`).join('')}</div>
    <div><span class="mn-col-lbl">Heart</span>${f.heartNotes.map(n=>`<span class="mn-note">${n}</span>`).join('')}</div>
    <div><span class="mn-col-lbl">Base</span>${f.baseNotes.map(n=>`<span class="mn-note">${n}</span>`).join('')}</div>`;
  document.getElementById('mBottle').innerHTML=bsvg(f,120,280);
  renderMSizes(f);
  document.getElementById('fModal').classList.add('open');
  document.body.style.overflow='hidden';
}
function renderMSizes(f) {
  document.getElementById('mSizes').innerHTML=SIZES.map(sz=>
    `<div class="ms-opt ${sz===mSelSize?'sel':''}" onclick="selMSize('${sz}')">
      <span class="ms-size">${sz}</span>
      <span class="ms-price">£${f.prices[sz]}</span>
      <span class="ms-note">${SIZE_NOTES[sz]}</span>
    </div>`).join('');
}
function selMSize(sz) { mSelSize=sz; if(curFrag) renderMSizes(curFrag); }
function closeMod(e) {
  if(e&&e.target!==document.getElementById('fModal')) return;
  document.getElementById('fModal').classList.remove('open');
  document.body.style.overflow='';
}
function addCart() {
  const btn=document.querySelector('.m-add');
  btn.textContent='Reserved — '+mSelSize+' — £'+(curFrag?curFrag.prices[mSelSize]:'');
  btn.style.background='var(--gold-d)';
  setTimeout(()=>{btn.textContent='Pre-Order This Fragrance';btn.style.background='';},2800);
}

// CURSOR
const cur=document.getElementById('cur'),ring=document.getElementById('cur-ring');
let mx=0,my=0,rx=0,ry=0;
document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;cur.style.left=mx+'px';cur.style.top=my+'px';});
(function tick(){rx+=(mx-rx)*.12;ry+=(my-ry)*.12;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(tick);})();
document.querySelectorAll('a,button,.qopt,.cbox,.enh,.spill,.wlb,.tsp,.ms-opt').forEach(el=>{
  el.addEventListener('mouseenter',()=>{ring.style.width='48px';ring.style.height='48px';ring.style.borderColor='rgba(201,168,76,.8)';});
  el.addEventListener('mouseleave',()=>{ring.style.width='32px';ring.style.height='32px';ring.style.borderColor='rgba(201,168,76,.45)';});
});

// NAV
window.addEventListener('scroll',()=>document.getElementById('nav').classList.toggle('sc',scrollY>60));

// REVEAL
const obs=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting)x.target.classList.add('vis')}),{threshold:.08,rootMargin:'0px 0px -50px 0px'});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

// COUNTDOWN
const drop=new Date(window.SAR_DROP_DATE||'2026-05-15T12:00:00Z');
function tick2() {
  const d=drop-new Date();
  if(d<=0){['ctD','ctH','ctM','ctS'].forEach(i=>document.getElementById(i).textContent='00');return;}
  document.getElementById('ctD').textContent=String(Math.floor(d/86400000)).padStart(2,'0');
  document.getElementById('ctH').textContent=String(Math.floor(d%86400000/3600000)).padStart(2,'0');
  document.getElementById('ctM').textContent=String(Math.floor(d%3600000/60000)).padStart(2,'0');
  document.getElementById('ctS').textContent=String(Math.floor(d%60000/1000)).padStart(2,'0');
}
tick2(); setInterval(tick2,1000);

// QUIZ
let cQ=1, ans={};
function updProg(q){const p=Math.round(((q-1)/5)*100);document.getElementById('qFill').style.width=p+'%';document.getElementById('qPL').textContent='Question '+q+' of 5';document.getElementById('qPP').textContent=p+'%';}
function nextQ(n){const sel=document.querySelector('.qq[data-q="'+n+'"] .qopt.sel');if(!sel)return;ans[n]=sel.dataset.v;document.querySelector('.qq[data-q="'+n+'"]').classList.remove('act');const nx=document.querySelector('.qq[data-q="'+(n+1)+'"]');if(nx){nx.classList.add('act');cQ=n+1;updProg(cQ);}}
function prevQ(n){document.querySelector('.qq[data-q="'+n+'"]').classList.remove('act');const pv=document.querySelector('.qq[data-q="'+(n-1)+'"]');if(pv){pv.classList.add('act');cQ=n-1;updProg(cQ);}}
document.querySelectorAll('.qopt').forEach(o=>o.addEventListener('click',()=>{o.closest('.qq').querySelectorAll('.qopt').forEach(x=>x.classList.remove('sel'));o.classList.add('sel');const b=o.closest('.qq').querySelector('.qnxt');if(b)b.classList.add('en');}) );

function recommend(){
  const sc={};FRAGS.forEach(f=>sc[f.id]=0);
  const m={
    1:{evening:{oud_al_layl:3,qalb_al_layl:2,sihr_al_masaa:2},intimate:{ward_al_arz:2,zahra_al_layl:2,mazaj_al_raheel:1},golden:{ward_al_fajr:2,nahr_al_dhahab:2,dhahab_al_sharq:1},ceremony:{oud_al_malik:3,dhahab_al_sharq:2,zafran_al_malik:1}},
    2:{oud:{oud_al_layl:4,jabal_al_nar:3,qalb_al_layl:2},floral:{ward_al_arz:4,ward_al_fajr:3,yasmin_al_sham:2},spice:{dhahab_al_sharq:4,zafran_al_malik:3,bukhoor_al_sham:2},cedar:{ruh_al_arz:4,nismat_al_bahr:2,ward_al_arz:1}},
    3:{whisper:{nismat_al_bahr:3,ward_al_fajr:2,mazaj_al_raheel:2},signature:{dhahab_al_sharq:2,oud_al_malik:2,nahr_al_dhahab:1},statement:{jabal_al_nar:3,oud_al_malik:3,qalb_al_layl:2},shifting:{sihr_al_masaa:3,zahra_al_layl:2,anbar_al_khalij:1}},
    4:{desire:{zahra_al_layl:3,oud_al_layl:3,sihr_al_masaa:2},awe:{oud_al_malik:3,dhahab_al_sharq:3,zafran_al_malik:2},mystery:{qalb_al_layl:4,jabal_al_nar:3,sihr_al_masaa:2},comfort:{mazaj_al_raheel:3,anbar_al_khalij:2,nahr_al_dhahab:2}},
    5:{oud_h:{oud_al_layl:4,oud_al_malik:3,jabal_al_nar:2},rose_h:{ward_al_arz:4,ward_al_fajr:3,zafran_al_malik:2},cedar_h:{ruh_al_arz:4,ward_al_arz:2,nismat_al_bahr:1},amber_h:{dhahab_al_sharq:4,anbar_al_khalij:3,bukhoor_al_sham:2}}
  };
  for(let q=1;q<=5;q++){const a=ans[q];if(a&&m[q]&&m[q][a])Object.entries(m[q][a]).forEach(([k,v])=>{if(sc[k]!==undefined)sc[k]+=v;});}
  return Object.entries(sc).sort((a,b)=>b[1]-a[1])[0][0];
}

let rSizeAdd=0;
function showRes(){
  const sel=document.querySelector('.qq[data-q="5"] .qopt.sel');if(!sel)return;
  ans[5]=sel.dataset.v;
  const id=recommend(); curFrag=FRAGS.find(f=>f.id===id);
  const f=curFrag;
  document.getElementById('qFill').style.width='100%';document.getElementById('qPL').textContent='Complete';document.getElementById('qPP').textContent='100%';
  document.querySelectorAll('.qq').forEach(q=>q.classList.remove('act'));
  document.getElementById('qRes').classList.add('act');
  document.getElementById('rAr').innerHTML=f.ar;
  document.getElementById('rEn').textContent=f.en;
  document.getElementById('rWest').textContent=f.western;
  document.getElementById('rTitle').innerHTML=f.en+' &nbsp;&middot;&nbsp; <em>'+f.western+'</em>';
  document.getElementById('rDesc').textContent=f.desc;
  document.getElementById('rAcc').innerHTML=f.accords.map(a=>'<span class="acc-tag">'+a+'</span>').join('');
  const all=[...f.topNotes,...f.heartNotes,...f.baseNotes];
  document.getElementById('rNotes').innerHTML=all.map(n=>'<span class="rn-it">'+n+'</span>').join('');
  document.getElementById('rBotSvg').innerHTML=bsvg(f,120,270);
  rSizeAdd=f.prices['6ml']; 
  renderSizePills(f);
  updSum();
  document.getElementById('qRes').scrollIntoView({behavior:'smooth',block:'start'});
}

function renderSizePills(f){
  document.getElementById('rSizePills').innerHTML=SIZES.map(sz=>
    `<div class="spill ${sz==='6ml'?'sel':''}" onclick="selResSize(this,'${sz}')">
      <span class="spill-sz">${sz}</span>
      <span class="spill-pr">£${f.prices[sz]}</span>
    </div>`).join('');
  rSizeAdd=f.prices['6ml'];
}
function selResSize(el,sz){
  document.querySelectorAll('#rSizePills .spill').forEach(p=>p.classList.remove('sel'));
  el.classList.add('sel');
  rSizeAdd=curFrag?curFrag.prices[sz]:0;
  updSum();
}

function updSum(){
  if(!curFrag)return;
  const eng=document.getElementById('eInput')?.value||'';
  const total=rSizeAdd+packAdd+(eng.length>0?45:0);
  document.getElementById('sumName').textContent=curFrag.en+' — '+curFrag.western+(eng?' · "'+eng+'"':'');
  document.getElementById('sumTotal').textContent='£'+total;
}
function selBox(el,add){document.querySelectorAll('#cboxes .cbox').forEach(b=>b.classList.remove('sel'));el.classList.add('sel');packAdd=add;updSum();}
function togEnh(el){const s=document.querySelectorAll('#enhancers .enh.sel');if(el.classList.contains('sel'))el.classList.remove('sel');else{if(s.length>=2)s[0].classList.remove('sel');el.classList.add('sel');}}
function restartQ(){ans={};cQ=1;document.getElementById('qRes').classList.remove('act');document.querySelectorAll('.qq').forEach(q=>q.classList.remove('act'));document.querySelectorAll('.qopt').forEach(o=>o.classList.remove('sel'));document.querySelectorAll('.qnxt').forEach(b=>b.classList.remove('en'));document.querySelector('.qq[data-q="1"]').classList.add('act');updProg(1);document.querySelector('.quiz').scrollIntoView({behavior:'smooth'});}
async function handleWL(e){
  e.preventDefault();
  const form = e.target.closest('form') || document.querySelector('.wl-form');
  const emailEl = form.querySelector('input[type="email"]');
  const phoneEl = form.querySelector('input[type="tel"]');
  const btn = document.getElementById('wlBtn');
  const email = emailEl ? emailEl.value.trim() : '';
  const phone = phoneEl ? phoneEl.value.trim() : '';
  if(!email) return false;

  btn.textContent = 'Adding you...';
  btn.disabled = true;

  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        list_id: 'S638RZ',
        email: email,
        ...(phone ? { phone_number: phone } : {}),
        properties: { source: 'Sar Al Oud Waitlist' }
      }
    }
  };

  try {
    const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VUqEUe', {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify(payload)
    });
    if(res.ok || res.status === 202) {
      btn.textContent = 'You are on the list.';
      btn.style.background = 'var(--gold-d)';
      btn.style.color = '#0a0804';
      emailEl.value = '';
      if(phoneEl) phoneEl.value = '';
      setTimeout(()=>{ btn.textContent='Notify Me'; btn.style.background=''; btn.style.color=''; btn.disabled=false; }, 5000);
    } else {
      throw new Error('status ' + res.status);
    }
  } catch(err) {
    btn.textContent = 'Try again';
    btn.style.background = 'rgba(180,60,60,.8)';
    btn.disabled = false;
    setTimeout(()=>{ btn.textContent='Notify Me'; btn.style.background=''; }, 3000);
    console.error('Klaviyo error:', err);
  }
  return false;
}

updProg(1);
buildGrid('all');

// PANEL SYSTEM
function openPanel(id) {
  document.getElementById(id).classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closePanel(id) {
  document.getElementById(id).classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.panel-overlay.open').forEach(p => p.classList.remove('open'));
    document.body.style.overflow = '';
  }
});

//
/* ============ SHOPIFY CART INTEGRATION (live commerce) ============ */
window.SAR_VARIANTS=null; window.SAR_ADDONS={};
function SARloadVariants(){
  return fetch('/products.json?limit=250').then(r=>r.json()).then(d=>{
    const map={}, add={};
    d.products.forEach(p=>{
      if(p.product_type==='Fragrance'){
        map[p.handle]={}; p.variants.forEach(v=>{ map[p.handle][v.title]=v.id; });
      } else if(p.product_type==='Add-on'){
        if(p.handle==='personal-engraving') add.engraving=p.variants[0].id;
        else if(p.handle==='marble-edition-presentation-box') add.marble=p.variants[0].id;
        else if(p.handle==='collectors-case') add.collector=p.variants[0].id;
      }
    });
    window.SAR_VARIANTS=map; window.SAR_ADDONS=add;
  }).catch(e=>console.error('SAR variant load failed',e));
}
SARloadVariants();
function SARvariant(f,size){
  if(!window.SAR_VARIANTS||!f) return null;
  const h=f.id.replace(/_/g,'-');
  return window.SAR_VARIANTS[h] ? window.SAR_VARIANTS[h][size] : null;
}
function SARcheckout(items, btn, restore){
  const orig = restore || (btn?btn.textContent:'');
  if(btn){ btn.textContent='Adding\u2026'; btn.style.pointerEvents='none'; btn.style.opacity='.7'; }
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
    .then(r=>{ if(!r.ok) throw new Error('add '+r.status); window.location.href='/checkout'; })
    .catch(e=>{ console.error(e); if(btn){btn.textContent='Try again';btn.style.pointerEvents='';btn.style.opacity='';setTimeout(function(){btn.textContent=orig;},2500);} });
}
addCart=function(){
  const btn=document.querySelector('.m-add');
  const vid=SARvariant(curFrag, mSelSize);
  if(!vid){ if(btn){btn.textContent='Unavailable';setTimeout(function(){btn.textContent='Pre-Order This Fragrance';},2000);} return; }
  SARcheckout([{id:vid,quantity:1}], btn, 'Pre-Order This Fragrance');
};
function SARbindCustom(){
  const res=document.getElementById('qRes'); if(!res) return;
  const btn=res.querySelector('.btn-g'); if(!btn||btn.dataset.sar) return;
  btn.dataset.sar='1';
  btn.addEventListener('click',function(e){
    e.preventDefault();
    if(!curFrag) return;
    const sizeEl=document.querySelector('#rSizePills .spill.sel .spill-sz');
    const size=sizeEl?sizeEl.textContent.trim():'6ml';
    const vid=SARvariant(curFrag,size);
    if(!vid){ btn.textContent='Unavailable'; setTimeout(function(){btn.textContent='Pre-Order My Bottle';},2000); return; }
    const eng=(document.getElementById('eInput')?document.getElementById('eInput').value:'').trim();
    const sl=document.getElementById('intSlider');
    const labs=['Intimate','Personal','Balanced','Projecting','Statement'];
    const sil=sl?labs[parseInt(sl.value,10)-1]:null;
    const enh=[].slice.call(document.querySelectorAll('#enhancers .enh.sel .enh-n')).map(function(x){return x.textContent.trim();});
    const props={};
    if(sil) props['Sillage']=sil;
    if(enh.length) props['Note Enhancers']=enh.join(', ');
    if(eng) props['Engraving']=eng;
    const item={id:vid,quantity:1}; if(Object.keys(props).length) item.properties=props;
    const items=[item]; const A=window.SAR_ADDONS||{};
    if(eng&&A.engraving) items.push({id:A.engraving,quantity:1,properties:{'For':curFrag.en+' \u00b7 "'+eng+'"'}});
    if(packAdd===65&&A.marble) items.push({id:A.marble,quantity:1});
    if(packAdd===160&&A.collector) items.push({id:A.collector,quantity:1});
    SARcheckout(items, btn, 'Pre-Order My Bottle');
  });
}
SARbindCustom();
document.addEventListener('DOMContentLoaded',SARbindCustom);
if(document.body){ new MutationObserver(SARbindCustom).observe(document.body,{childList:true,subtree:true}); }

/* ============ CONTACT FORM (posts to Shopify /contact) ============ */
function handleContact(e){
  e.preventDefault();
  var form = e.target;
  var btn = document.getElementById('cfBtn');
  var inps = form.querySelectorAll('.cf-inp');
  var name = inps[0] ? inps[0].value.trim() : '';
  var email = inps[1] ? inps[1].value.trim() : '';
  var subject = inps[2] ? inps[2].value.trim() : '';
  var ta = form.querySelector('.cf-ta');
  var msg = ta ? ta.value.trim() : '';
  if(!name || !email || !msg){ return false; }
  var subj = subject ? subject : 'Website enquiry';
  var bodyTxt = msg + '\n\n\u2014 ' + name + ' (' + email + ')';
  var href = 'mailto:Sar.aloud@icloud.com'
    + '?subject=' + encodeURIComponent(subj)
    + '&body=' + encodeURIComponent(bodyTxt);
  window.location.href = href;
  btn.textContent = 'Opening your email\u2026';
  setTimeout(function(){ btn.textContent='Send Message'; }, 4000);
  return false;
}

/* ============ COUNTDOWN "DROP IS LIVE" END-STATE ============ */
(function(){
  function checkDropState(){
    try{
      var drop = new Date(window.SAR_DROP_DATE || '2026-06-23T12:00:00Z');
      if(isNaN(drop.getTime())) return;
      if(drop - new Date() <= 0){
        var cd = document.querySelector('.hcd');
        if(cd && !cd.dataset.live){
          cd.dataset.live = '1';
          cd.innerHTML = '<span class="cdl" style="color:var(--gold);">The Drop Is Live</span>'
            + '<div style="font-family:\'Cormorant Garamond\',serif;font-style:italic;color:var(--muted);font-size:1rem;margin-top:8px;">'
            + 'Pre-order now \u2014 the edition is selling. When 250 go, they go.</div>';
        }
      }
    }catch(e){}
  }
  checkDropState();
  setInterval(checkDropState, 1000);
  document.addEventListener('DOMContentLoaded', checkDropState);
})();

/* ============ CART DRAWER (review before checkout) ============ */
(function(){
  function money(cents){ return '\u00a3' + (cents/100).toFixed(2); }

  // Inject drawer DOM once
  function ensureDrawer(){
    if(document.getElementById('cartDrawer')) return;
    var d = document.createElement('div');
    d.className = 'panel-overlay';
    d.id = 'cartDrawer';
    d.innerHTML =
      '<div class="panel-backdrop" onclick="closeCart()"></div>'
      + '<div class="panel-drawer">'
      +   '<div class="panel-header">'
      +     '<div><span class="panel-pre">Your Selection</span><span class="panel-title">Your Cart</span></div>'
      +     '<button class="panel-close" onclick="closeCart()">\u00d7</button>'
      +   '</div>'
      +   '<div class="panel-body" id="cartBody"></div>'
      +   '<div class="cart-foot" id="cartFoot"></div>'
      + '</div>';
    document.body.appendChild(d);
  }

  // Inject a cart icon into the nav once
  function ensureNavCart(){
    var nav = document.getElementById('nav');
    if(!nav || document.getElementById('navCart')) return;
    var cta = nav.querySelector('.ncta');
    var btn = document.createElement('button');
    btn.id = 'navCart';
    btn.className = 'nav-cart';
    btn.setAttribute('aria-label','Cart');
    btn.setAttribute('onclick','SARopenCart()');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span class="nav-cart-badge" id="navCartBadge">0</span>';
    if(cta && cta.parentNode){ cta.parentNode.insertBefore(btn, cta); }
    else { nav.appendChild(btn); }
  }

  function renderCart(cart){
    var body = document.getElementById('cartBody');
    var foot = document.getElementById('cartFoot');
    if(!body||!foot) return;
    if(!cart.items || cart.items.length===0){
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      foot.innerHTML = '';
      updateBadge(0);
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var props = '';
      if(it.properties){
        Object.keys(it.properties).forEach(function(k){
          if(k.charAt(0)==='_') return;
          var v = it.properties[k];
          if(v===null || v==='' ) return;
          props += '<div class="ci-prop"><span>'+k+':</span> '+v+'</div>';
        });
      }
      html +=
        '<div class="cart-item">'
        + '<div class="ci-main">'
        +   '<div class="ci-name">'+ (it.product_title||it.title) +'</div>'
        +   (it.variant_title && it.variant_title!=='Default Title' ? '<div class="ci-variant">'+it.variant_title+'</div>' : '')
        +   props
        +   '<div class="ci-qty">'
        +     '<button onclick="SARcartChange(\''+it.key+'\','+(it.quantity-1)+')" aria-label="Decrease">\u2212</button>'
        +     '<span>'+it.quantity+'</span>'
        +     '<button onclick="SARcartChange(\''+it.key+'\','+(it.quantity+1)+')" aria-label="Increase">+</button>'
        +     '<button class="ci-remove" onclick="SARcartChange(\''+it.key+'\',0)">Remove</button>'
        +   '</div>'
        + '</div>'
        + '<div class="ci-price">'+ money(it.final_line_price) +'</div>'
        + '</div>';
    });
    body.innerHTML = html;
    foot.innerHTML =
      '<div class="cart-sub"><span>Subtotal</span><span>'+ money(cart.total_price) +'</span></div>'
      + '<p class="cart-note">Shipping &amp; any taxes are calculated at checkout.</p>'
      + '<button class="cart-checkout" onclick="SARgoCheckout()">Proceed to Checkout</button>';
    updateBadge(cart.item_count);
  }

  function updateBadge(n){
    var b = document.getElementById('navCartBadge');
    if(b){ b.textContent = n; b.style.display = n>0 ? 'flex' : 'none'; }
  }

  window.SARopenCart = function(){
    ensureDrawer();
    var fm = document.getElementById('fModal'); if(fm) fm.classList.remove('open');
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      renderCart(cart);
      document.getElementById('cartDrawer').classList.add('open');
      document.body.style.overflow='hidden';
    }).catch(function(e){ console.error('cart open',e); });
  };
  window.closeCart = function(){
    var d = document.getElementById('cartDrawer');
    if(d) d.classList.remove('open');
    document.body.style.overflow='';
  };
  window.SARcartChange = function(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key, quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart)
      .catch(function(e){ console.error('cart change',e); });
  };
  window.SARgoCheckout = function(){ window.location.href='/checkout'; };

  function refreshBadge(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ updateBadge(c.item_count); }).catch(function(){});
  }

  // Override SARcheckout: add to cart, then OPEN DRAWER instead of redirecting
  SARcheckout = function(items, btn, restore){
    var orig = restore || (btn?btn.textContent:'');
    if(btn){ btn.textContent='Adding\u2026'; btn.style.pointerEvents='none'; btn.style.opacity='.7'; }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
      .then(function(r){ if(!r.ok) throw new Error('add '+r.status);
        if(btn){ btn.textContent='Added \u2713'; setTimeout(function(){ btn.textContent=orig; btn.style.pointerEvents=''; btn.style.opacity=''; },2500); }
        return window.SARopenCart();
      })
      .catch(function(e){ console.error(e); if(btn){ btn.textContent='Try again'; btn.style.pointerEvents=''; btn.style.opacity=''; setTimeout(function(){btn.textContent=orig;},2500);} });
  };

  function init(){ ensureDrawer(); ensureNavCart(); refreshBadge(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  // Escape closes cart too
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });
})();
